import { Card } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { fromArrayMaybe } from 'nonempty-list';
import EmptyActivityComponent from '../../../EmptyComponents/EmptyActivityComponent';
import Title from '../../Shared/Title';
import Row from './Row';
import { PopularCompetencyPayload } from '../PopularCompetencies/Decoder';

interface Props {
  popularCompetencies: PopularCompetencyPayload[];
}

function PopularCompetenciesList({ popularCompetencies }: Props) {
  return (
    <Card className="px-4 py-6" radius="lg">
      <div className="flex justify-between">
        <Title label="Competencies" />
        <Title label="Enrollments" />
      </div>
      <div className="max-h-12">
        {fromArrayMaybe(popularCompetencies)
          .map((popularCompetencies) => <Row popularCompetencies={popularCompetencies} />)
          .getOrElse(() => (
            <EmptyActivityComponent />
          ))}
      </div>
    </Card>
  );
}

export default observer(PopularCompetenciesList);
